module.exports = __webpack_public_path__ + "static/img/2.506a990.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/zh/2.png
// module id = 2i5l
// module chunks = 0